
//Creates a full JSON representation of the enrolment state
export function generateJSON(enrolmentState) {
    const attributes = [
        'aces',
        'setAces',
        'agent',
        'application',
        'beneficiary',
        'common',
        'configuration',
        'dependant',
        'knowYourClient',
        'plan',
        'plan2',
        'subscriber',
        'jointSubscriber',
        'transfer',
        'quote',
        'quote2',
        'docusign',
        'enrollment',
        'drChecklist',
    ]

    let ret = {};

    for (let attr of attributes) {
        ret[attr] = enrolmentState[attr];
    }

    return JSON.stringify(ret, null, 2);
}